import { FilterAltOutlined } from '@mui/icons-material';
import { Badge, Checkbox, Drawer, FormControlLabel, IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type UserFilterDrawerProps = {
  showDeactivated: boolean;
  onShowDeactivatedChange: (showDeactivated: boolean) => void;
};

export function UserFilterDrawer({ showDeactivated, onShowDeactivatedChange }: UserFilterDrawerProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <IconButton
        aria-label={t('userAccessControl.filters.title')}
        data-qa-element-id="user_filter_button"
        onClick={() => setOpen(true)}
        sx={{ color: 'primary.main' }}
      >
        <Badge color="primary" variant="dot" invisible={!showDeactivated}>
          <FilterAltOutlined />
        </Badge>
      </IconButton>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        ModalProps={{ keepMounted: true }}
        slotProps={{
          root: { sx: (theme) => ({ zIndex: theme.zIndex.modal }) },
          paper: { sx: { bottom: 'var(--bottom-nav-bar-height)' } },
        }}
      >
        <Stack width="100%" maxWidth="100vw" p={2} gap={1}>
          <Typography variant="h6" fontWeight={500}>
            {t('userAccessControl.filters.title')}
          </Typography>
          <FormControlLabel
            control={
              <Checkbox checked={showDeactivated} onChange={(event) => onShowDeactivatedChange(event.target.checked)} />
            }
            label={t('userAccessControl.filters.showDeactivated')}
          />
        </Stack>
      </Drawer>
    </>
  );
}
